import { useQuery } from '@tanstack/react-query';
import { authenticatedFetch } from '../utils';

/**
 * Fetch the current tenant's AI usage wallet.
 *
 * Usage is rolling — it never resets.
 * Any positive-duration call is billed as whole minutes
 * (rounded to nearest, minimum 1 min).
 *
 * Returns:
 *   minutes_used        — total whole minutes consumed (all time)
 *   total_allocated     — initial grant + all topups (null = unlimited)
 *   balance             — minutes remaining in wallet (null = unlimited)
 *   total_topups        — total topup minutes added by admin
 *   is_limited          — boolean
 *   percentage_used     — number (0–100), 0 when unlimited
 *   is_over_limit       — boolean (balance ≤ 0)
 */
export const useUsageQuery = (enabled = true) => {
  return useQuery({
    queryKey: ['ai-usage-current'],
    queryFn: async () => {
      const response = await authenticatedFetch('/api/usage/current');
      if (!response.ok) throw new Error('Failed to fetch usage data');
      return response.json();
    },
    staleTime: 60 * 1000,   // 1-minute cache
    enabled,
  });
};
